define('imovelusuario-resource',['i18n-provider', 'app-route-provider', 'notify-service'], function() {
  var app = angular.module('imovelusuario.resource', ['i18n.provider', 'app.route.provider', 'notify.service']);
  app.factory('Imovelusuario', ['$q', '$http', '$location', '$state', 'i18n', 'appRoute', 'notify',
    function($q, $http, $location, $state, i18n, appRoute, notify, $multipart) {
      return {
        saveImg: function(data) {
          return $http.post(appRoute.linkTo('imovelusuario.uploadImg'), data).then(function(result){
            return result;
          });
        },
        getImoveis: function(data) {
          return $http.post(appRoute.linkTo('imovelusuario.getImoveis'), data).then(function(result){
            return result;
          });
        },
        createThumb: function(imo_codigo) {
          return $http.get(appRoute.linkTo('imovelusuario.createThumb', {'imou_codigo':imou_codigo}));
        },
        create:function(data){
          return $q(function (resolve, reject) {
            return $http.post(appRoute.linkTo('imovelusuario.create'), data).success(function (data) {
              resolve(data);
            }).error(function (error) {
              reject(error);
            });
          });
        },
        getCidadeByEstado:function (est_codigo, cid_nome) {//index de amostra
          return $q(function (resolve, reject) {
            $http.get(appRoute.linkTo('imovelusuario.getCidadeByEstado', {'est_codigo':est_codigo, 'cid_nome':cid_nome})).success(function (data) {
              resolve(data);
            }).error(function (error) {
              if (error && error.notifications && !_.isEmpty(error.notifications)) {
                //notify.addNotification(error.notifications);
              } else {
                //notify.addNotification('danger', i18n.__('couldNotLoadFemaleRecords', i18n.__('imobiliariaLayout')));
              }
              reject(error);
            });
          });
        },
        successUploadImgImovelusuario:function(data){
          return $q(function (resolve, reject) {
            return $http.post(appRoute.linkTo('imovelusuario.successUploadImgImovelusuario'), data).success(function (data) {
              resolve(data);
            }).error(function (error) {
              reject(error);
            });
          });
        },
      }
    }
  ]);
});


